import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    maxWidth: '500px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '400px'
    }
  },
  card: {
    width: '100%',
    background: theme.palette.grey[100],
    borderRadius: '18px',
    padding: '32px 28px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 18px',
      borderRadius: '14px'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16px 14px',
      borderRadius: '12px'
    }
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      marginBottom: '10px'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
      marginBottom: '8px'
    }
  },
  description: {
    color: theme.palette.text.primary,
    marginBottom: '4px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px'
    }
  },
  suggestion: {
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px'
    }
  }
}))
